import React from 'react';
import { useUser } from '@clerk/clerk-react';
import { Loader2 } from 'lucide-react';
import LandingPage from './LandingPage';

export default function AuthPage() {
  const { isSignedIn, isLoaded } = useUser();

  if (!isLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <Loader2 className="w-8 h-8 text-violet-400 animate-spin" />
      </div>
    );
  }

  if (isSignedIn) {
    // Already signed in, this shouldn't show
    return null;
  }

  // Show full landing page when not signed in
  return <LandingPage />;
}
